module.exports = __webpack_public_path__ + "img/target.9badaa66.png";